import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { IAppRequest } from '@app/app.interface';
import { FuiNotifierService, TFuiNotify } from '@fui/fui-components';

export enum ENotifyTypes {
    warning = 'warning',
    error = 'error',
    info = 'info',
    success = 'success',
}

@Injectable()
export class NotifierService {
    readonly #config = inject(AppConfig);
    readonly #notifier = inject(FuiNotifierService);

    /**
     * Показать всплывающее уведомление
     * @param type - тип
     * @param message - сообщение
     */
    public notify(type: ENotifyTypes | string, message: string): void {
        this.#notifier.show({ type: type as TFuiNotify, message });
    }

    /**
     * Показать всплывающее уведомление типа Success с настройками по умолчанию.
     * @param message - сообщение
     */
    public success(message: string) {
        this.notify('success', message);
    }

    /**
     * Показать всплывающее уведомление типа Info с настройками по умолчанию.
     * @param message - сообщение
     */
    public info(message: string) {
        this.notify('info', message);
    }

    /**
     * Показать всплывающее уведомление типа Warning с настройками по умолчанию.
     * @param message - сообщение
     */
    public warning(message: string) {
        this.notify('warning', message);
    }

    /**
     * Показать всплывающее уведомление типа Error с настройками по умолчанию.
     * @param message - сообщение
     */
    public error(message: string) {
        this.notify('error', message);
    }

    /**
     * Показать всплывающее уведомление типа Error для обработки JS ошибок типа Error.
     * Если текст ошибки начинается с ругательств на английском, или текст отсутствует вообще,
     * выводим "Нет связи с системой".
     * @param error объект типа { message?: string }
     */
    public exception(error?: any) {
        let message = error?.message;

        // Обработка 500х ошибок
        if (error instanceof HttpErrorResponse) {
            if (error.error instanceof ArrayBuffer) {
                try {
                    const result: IAppRequest = JSON.parse(new TextDecoder().decode(error.error));
                    message = result?.message;
                } catch {
                    message = error?.message;
                }
            } else if (error.error?.message) {
                message = error.error?.message;
            }
        }

        if (!message || /^\s*[A-Za-z]/.test(message)) {
            message = this.#config.languageDictionary.system_no_connection_with_system;
            console.warn(error);
        }
        this.notify('error', message);
    }
}
